import styled from '@emotion/styled';
import useControls from '../../hooks/use-controls';

import FullScreenIcon from './full-screen-icon';
import Pagination from './pagination';
import usePlayerState from '../../providers/player-providers/use-player-state';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export default function Controls() {
  const { resource, preventArrowKeysEvents, isSinglePdfOrGenially } =
    usePlayerState();
  useControls({ preventArrowKeysEvents });

  const showPagination = resource && 'resources' in resource;
  const showFullScreen = !isSinglePdfOrGenially;

  return (
    <Wrapper>
      {showPagination ? <Pagination /> : <div />}
      {showFullScreen && <FullScreenIcon />}
    </Wrapper>
  );
}
